import React from "react";
import { cn } from "helpers/style";
import styles from "./Payments.module.scss";

type Props = {
  showOnDesktop?: boolean;
};

const Payments: React.FC<Props> = ({ showOnDesktop }: Props) => (
  <div
    className={cn([
      styles.footer500Payments,
      showOnDesktop && styles.footer500PaymentsShowOnDesktop,
    ])}
  >
    <img src="/img/footer/visa.svg" alt="Visa" />
    <img src="/img/footer/master-card.svg" alt="Master card" />
    <img src="/img/footer/mir.svg" alt="Mir" />
    <img src="/img/footer/jcb.svg" alt="JCB" />
  </div>
);

export default Payments;
